// Open water swims are held in water, which has no terrain, so pairing a
// terrain with the swim activity type describes nothing and matches no event.
// Every place that holds or sends an event-search filter payload runs terrain
// through here, so the rule has one definition rather than one per component.
const SWIM_ACTIVITY = 'swim';

const terrainDisabledFor = (activityType) => activityType === SWIM_ACTIVITY;

// The terrain to search by, given the activity type it is paired with.
const terrainFor = (activityType, terrain) => (
  terrainDisabledFor(activityType) ? null : terrain || null
);

export { SWIM_ACTIVITY, terrainDisabledFor, terrainFor };
